import { render, staticRenderFns } from "./PetwishlistView.vue?vue&type=template&id=134130d4"
import script from "./PetwishlistView.vue?vue&type=script&lang=js"
export * from "./PetwishlistView.vue?vue&type=script&lang=js"
import style0 from "./PetwishlistView.vue?vue&type=style&index=0&id=134130d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports